import { parseStringField } from "helpers/FieldHelper";
import { changeDateFormat } from 'helpers/DateHelper';
import * as ConfigTypes from 'config/ConfigTypes';

export const getFieldTxt = ({ item, el, i, idx, viewMode = ConfigTypes.CARTREQUEST_LIST  }) => {
    let fieldTxt;
    let subType = el[`${viewMode}type`];
    fieldTxt = parseStringField(item.metadata.fields[el.field]);
    if (el.type === ConfigTypes.INDEX) fieldTxt = (idx + 1).toString();
    if (el.type === ConfigTypes.SHOWDATES) {
        if (item[el.type]) {
            let dates = item[el.type];
            dates = dates.map(date => changeDateFormat({ date: new Date(date) }))
            fieldTxt = dates.join(", ");
        }
        else fieldTxt = '';
    }
    if (el.type === ConfigTypes.SHOWS) {
        if (item[el.type] && item[el.type].length) {
            fieldTxt = item[el.type].reduce((prev, cur) => {
                cur = prev + cur;
                return cur;
            }, 0);
        }
        else fieldTxt = '';
    }
    if (subType && subType == ConfigTypes.COMBINE) {
        let groupFields = el[`${viewMode}group`]
        fieldTxt = groupFields.split(";").map(sub => item.item[sub]).join(" ");
    }

    return fieldTxt;
}


export const showComplexElement = ({ el, idx, obj, viewMode, fm }) => {
    let data = el[`${viewMode}data`];
    if(!data) data = el.data;
    if (el && data) {
        return data.map((sub, index) => {
            let fieldTxt = '0';
            if (obj && obj[el.field] && obj[el.field][sub.field]) {
                fieldTxt = obj[el.field][sub.field];
                let display = parseInt(fieldTxt) / 100;
                fieldTxt = display.toFixed(2);
            }
            return (
                <div className={`${sub.htmlClasses ? sub.htmlClasses : ''}`}
                    key={`cartrequest_ul_li_children${index}`}>
                    <label> {sub.intl ? `${fm({id: sub.intl})} ` : ''}</label>
                    {fieldTxt}
                </div>
            )
        })
    }
}

